// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { doesNotHaveExpand, post } from "@insite/client-framework/Services/ApiService";
import { CreateShipToApiParameter } from "@insite/client-framework/Services/CustomersService";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";

const billTosUrl = "/api/v1/billtos";

function cleanShipToModel(
    shipToModel: Partial<ShipToModel>,
    parameter?: { expand?: string[]; additionalExpands?: string[] },
) {
    if (doesNotHaveExpand(parameter, "validation")) {
        delete shipToModel.validation;
    }
    if (shipToModel.id?.trim() === "") {
        shipToModel.id = shipToModel.label;
    }
}

export async function xngCreateShipTo(parameter: CreateShipToApiParameter) {
    try {
        const shipTo = await post<ShipToModel>(
            `${billTosUrl}/${parameter.billToId ?? "current"}/shiptos`,
            parameter.shipTo,
        );
        cleanShipToModel(shipTo);
        return shipTo;
    } catch (error) {
        if ((error as any).errorJson?.message) {
            return {
                successful: false,
                errorMessage: (error as any).errorJson.message,
            };
        }
        throw error;
    }
}
